const defualtState = {};

export default (state = defualtState, action) => {
  switch (action.type) {
    case 'USER_LOGIN_SUCCESS': {
      if (action.user !== null) {
        localStorage.setItem('2fa-auth', JSON.stringify(action.user));
        localStorage.removeItem('jwtToken');
      } else {
        localStorage.removeItem('2fa-auth');
        localStorage.setItem('jwtToken', action.token);
        // Clear idle-tracking state so the new session starts clean
        localStorage.removeItem('countdown-modal-open');
        localStorage.removeItem('idle-timer');
        localStorage.removeItem('lastActivity');
      }
      return action.user || defualtState;
    }
    case 'UPDATE_USER_BY_ID_SUCCESS': {
      return state.name === action.user.data.name
        ? { ...action.user.data, company: state.company, gravatar: state.gravatar }
        : state;
    }
    case 'FETCH_USER_SUCCESS':
      localStorage.setItem('resetPassword', action.user?.resetPassword || false);
      return action.user || defualtState;
    case 'FETCH_USER_FAILURE':
      return defualtState;
    case 'USER_LOGOUT_SUCCESS':
      localStorage.removeItem('jwtToken');
      localStorage.removeItem('recentBoxes');
      localStorage.removeItem('resetPassword');
      return defualtState;
    case 'USER_DISABLED':
        return { ...state, error: action.error, isLoggedIn: false };
    default:
      return state;
  }
};
